import { Stack } from '@mui/material'
import { useState } from 'react'

import { TextField, TextFieldProps } from './TextField'
import type { Dispatch } from 'redux'
import { useAppSelector } from 'redux/Hook'
import PermaLink, { PermaLinkProps } from './PermaLink'

interface TextFieldWithPermaLinkProps extends Omit<TextFieldProps, 'onChange'> {
  id: string
  label: string
  textFieldProps?: Partial<TextFieldProps>
  permaLinkProps: PermaLinkProps
  onChange: (name: string, value: string, dispatch: Dispatch) => void
}

const TextFieldWithPermaLink = (props: TextFieldWithPermaLinkProps) => {
  const {
    id,
    label,
    textFieldProps,
    permaLinkProps,
    onChange,
    inputProps,
    ...rest
  } = props

  const value = useAppSelector(
    (state) => state.toolBuilder.toolBuilder?.[id] || '',
  )
  const [childrenValue, setChildrenValue] = useState('')

  const handleBlur = () => {
    setChildrenValue(value)
  }

  return (
    <Stack spacing={2}>
      <TextField
        id={id}
        label={label}
        {...textFieldProps}
        onChange={onChange}
        onBlur={handleBlur}
        inputProps={inputProps}
        {...rest}
      />
      <PermaLink
        {...permaLinkProps}
        inputProps={inputProps}
        parentValue={childrenValue}
      ></PermaLink>
    </Stack>
  )
}

export default TextFieldWithPermaLink
